export const MaleIcon = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758795011265"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M151.1936 310.528a407.04 407.04 0 0 1 537.344-33.792l143.0528-143.0016h-80.6912a50.8928 50.8928 0 0 1 0-101.7344h203.4688c28.16 0 50.8928 22.784 50.8928 50.8416v203.52a50.8416 50.8416 0 1 1-101.7344 0V205.6704l-143.0016 143.0528A407.04 407.04 0 0 1 151.1936 886.016a406.9888 406.9888 0 0 1 0-575.5392m71.936 71.936a305.2032 305.2032 0 1 0 431.616 431.616 305.2032 305.2032 0 0 0-431.616-431.616"
      fill="#14BCD0"
      p-id="9260"
    ></path>
  </svg>
);

export const FemaleIcon = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758795175516"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M739.230476 82.651429l73.094095 73.142857 60.708572-60.708572a48.469333 48.469333 0 1 1 72.557714 63.975619l-3.998476 4.534857-60.757333 60.65981 73.142857 73.142857a48.615619 48.615619 0 1 1-68.754286 68.803048l-73.142857-73.142857-87.771429 87.771428A387.657143 387.657143 0 0 1 143.993905 892.68419a387.608381 387.608381 0 0 1 511.75619-580.266666l87.820191-87.771429-73.142857-73.142857a48.615619 48.615619 0 0 1 68.754285-68.803048zM212.455619 413.013333a290.669714 290.669714 0 1 0 411.062857 411.062857 290.669714 290.669714 0 0 0-411.062857-411.062857z"
      fill="#D01484"
      p-id="9408"
    ></path>
  </svg>
);
